import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication/authentication.service';
import { LoggingService } from './logging/logging.service';
import { CreateBookModel, Book, EditBookModel } from '../models/inModels/Book';
import { LazyLoadEvent } from '../models/DataTables/lazyLoadEvent';


@Injectable()
export class BookService {
	private routeCategory = '/api/books';
	constructor(
		private http: HttpClient,
		private auth: AuthenticationService,
		private logging: LoggingService
	) { }

	search(event: LazyLoadEvent): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/search`, JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	get(id: number): Promise<Book> {
		return this.http.get(`${this.auth.apiUrl}${this.routeCategory}/get/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response as Book)
			.catch(error => this.logging.handleError(error));
	}

	create(user: CreateBookModel): Promise<Book> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/create`, JSON.stringify(user), { headers: this.auth.header })
			.toPromise()
			.then(response => response as Book)
			.catch(error => this.logging.handleError(error));
	}

	delete(id: number): Promise<any> {
		return this.http.get(`${this.auth.apiUrl}${this.routeCategory}/delete/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	update(user: EditBookModel): Promise<Book> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/update`, JSON.stringify(user), { headers: this.auth.header })
			.toPromise()
			.then(response => response as Book)
			.catch(error => this.logging.handleError(error));
	}

	addDiscount(user: Book): Promise<Book> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/add/discount`, JSON.stringify(user), { headers: this.auth.header })
			.toPromise()
			.then(response => response as Book)
			.catch(error => this.logging.handleError(error));
	}

	getDropdown(event): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/dropdown`,JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}
}



// WEBPACK FOOTER //
// ./src/app/services/book.service.ts